jQuery(function ($) {
  jQuery('.modal').on('hide.bs.modal', function (e) {
    let $video = jQuery(this).find('video');
    
    if($video.length > 0) {
      $video[0].pause();
    }
  });
});